import styled from 'styled-components';

const DescriptionChoiceContainer = styled.div``;

export default DescriptionChoiceContainer;
